import { createContext, ReactNode, useContext, useState } from 'react'

type HelpCenterDialogContextType = {
    isHelpOpen: boolean
    openHelp: () => void
    closeHelp: () => void
}
const defaultContextValue: HelpCenterDialogContextType = {
    isHelpOpen: false,
    openHelp: () => undefined,
    closeHelp: () => undefined,
}

const HelpCenterDialogContext = createContext<HelpCenterDialogContextType>(defaultContextValue)
export const useHelpCenterDialogContext = () => useContext(HelpCenterDialogContext)

export const HelpCenterDialogProvider = ({ children }: { children: ReactNode }) => {
    const [isHelpOpen, setHelpOpen] = useState(false)

    const value = {
        isHelpOpen,
        openHelp: () => setHelpOpen(true),
        closeHelp: () => setHelpOpen(false),
    }

    return <HelpCenterDialogContext.Provider value={value}>{children}</HelpCenterDialogContext.Provider>
}
